<template>
    <div>
        <el-dialog :visible.sync="configInfo.confirmVisible"
                   :modal-append-to-body="false"
                    >
            <div class="drawer-top">
                {{configInfo.options.tableComment}}
            </div>

            <avue-form ref="confirmForm"
                        :option="configInfo.options"
                        v-model="configInfo.modeldata">
            </avue-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose()" >取消</el-button>
                    <!--<el-button v-if="configInfo.buttonSetting.buttomButtonName" type="primary" @click="Handle('handleSubmit',configInfo.modeldata)">{{configInfo.buttonSetting.buttomButtonName}}</el-button>
                    --><el-button type="primary" @click="Handle('handleSubmit',configInfo.modeldata)">确认</el-button>
             </span>

        </el-dialog>


    </div>

</template>

<script>

    import { deepClone } from '@/framework/util/util.js'
    export default {
        data(){
            return {

            }
        },
        props: ['configInfo'],
        methods: {
            Handle(e, formName) {
                // 数据验证
                this.$refs.confirmForm.validate((valid) => {
                    if (valid) {
                        this.$emit(e, deepClone(formName))
                    }
                })
            },
            handleClose(){
                this.configInfo.confirmVisible = false
            },
        }

    }

</script>
<style lang="scss" scoped>
    .drawer-top{
        position: relative;
        margin-top: -20px;
        margin-left: 40px;
        margin-right: 40px;
        padding-bottom: 15px;
        text-align: center;
        font-size: 25px;
        font-weight: bold;
        //border: 1px solid red;


    }
</style>